import LayersOutlined from "@mui/icons-material/LayersOutlined";

import styles from "./Card.module.css";
import {
  WORKFLOW_CARDS_MORE,
  WORKFLOW_CARDS_MORE_COMING_SOON,
} from "./constants";

const CardMore: React.FC = () => {
  const onCardClick = () => {};

  return (
    <div className={styles.cardItemComingSoon} onClick={onCardClick}>
      <div className={styles.cardContent}>
        <div className={styles.circle}>
          <LayersOutlined className={styles.icon} />
        </div>
        <div className={styles.text}>
          <div className={styles.title}>{WORKFLOW_CARDS_MORE}</div>
          <div className={styles.description}>{WORKFLOW_CARDS_MORE_COMING_SOON}</div>
        </div>
      </div>
    </div>
  );
};

export default CardMore;
